import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	none: {
		id: 'servicedesk-customer-service-custom-details.common.layout.value-container.none',
		defaultMessage: 'None',
		description: 'Default copy displayed when field value is empty or undefined',
	},
});
